import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StoryCategoryPage from "../pages/category/story/page";
import CastCategoryPage from "../pages/category/cast/page";
import ClipCategoryPage from "../pages/category/clip/page";
import StoryDetailPage from "../pages/detail/story/page";
import CastDetailPage from "../pages/detail/cast/page";
import ClipDetailPage from "../pages/detail/clip/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/story",
    element: <StoryCategoryPage />,
  },
  {
    path: "/category/cast",
    element: <CastCategoryPage />,
  },
  {
    path: "/category/clip",
    element: <ClipCategoryPage />,
  },
  {
    path: "/detail/story/:id",
    element: <StoryDetailPage />,
  },
  {
    path: "/detail/cast/:id",
    element: <CastDetailPage />,
  },
  {
    path: "/detail/clip/:id",
    element: <ClipDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;